import React from 'react';
import { Instagram, Facebook, Twitter, Youtube, Twitch, Music, Link, Mail } from 'lucide-react';

const ConnectSection: React.FC = () => {
  const socialLinks = [
    { name: 'Instagram', icon: <Instagram />, url: 'https://instagram.com/djltime' },
    { name: 'Facebook', icon: <Facebook />, url: 'https://www.facebook.com/people/DJ-Landan-Time-Music/61575796143813/' },
    { name: 'Twitter', icon: <Twitter />, url: 'https://twitter.com/djlandantime' },
    { name: 'YouTube', icon: <Youtube />, url: 'https://youtube.com/@djlandantime' },
    { name: 'Twitch', icon: <Twitch />, url: 'https://twitch.tv/djlandantime' },
    { name: 'Apple Music', icon: <Music />, url: 'https://music.apple.com/gb/album/tell-me-clubsoul-remix-single/1870512657' },
  ];

  return (
    <section id="connect" className="py-24 bg-gradient-to-b from-black via-purple-950/10 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">Connect With Me</h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Follow me on social media for the latest updates, upcoming events, and behind the scenes content.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-6 mb-12">
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.url}
              target="_blank"
              rel="noreferrer"
              className="flex flex-col items-center justify-center bg-gray-900/40 border border-purple-900/30 hover:border-purple-500/50 p-6 rounded-xl transition-all duration-300 hover:-translate-y-1 group"
            >
              <div className="w-12 h-12 flex items-center justify-center text-purple-400 group-hover:text-purple-300 transition-colors duration-300 mb-3">
                {social.icon}
              </div>
              <span className="text-gray-300 group-hover:text-white text-sm">{social.name}</span>
            </a>
          ))}
        </div>

        <div className="bg-gray-900/40 border border-purple-900/30 p-8 rounded-xl text-center">
          <div className="flex items-center justify-center mb-4">
            <Mail className="h-8 w-8 text-purple-400 mr-3" />
            <h3 className="text-2xl font-bold text-white">Get in Touch</h3>
          </div>
          <a
            href="mailto:dj@djlandantime.co.uk"
            className="text-purple-400 hover:text-purple-300 text-lg font-medium transition-colors"
          >
            dj@djlandantime.co.uk
          </a>
        </div>

        <div className="mt-16 text-center">
          <a
            href="https://ffm.bio/8y5padb"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center justify-center bg-purple-600 hover:bg-purple-700 text-white font-bold py-3 px-8 rounded-full shadow-lg hover:shadow-purple-500/30 transition-all duration-300"
          >
            <Link className="mr-2 h-5 w-5" />
            All My Links
          </a>
          <p className="mt-4 text-gray-500 text-sm">
            Find all my music, social media, and more in one place
          </p>
        </div>
      </div>
    </section>
  );
};

export default ConnectSection;